import { render, staticRenderFns } from "./PartnershipPostEdit.vue?vue&type=template&id=963488b4&"
import script from "./PartnershipPostEdit.vue?vue&type=script&lang=js&"
export * from "./PartnershipPostEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports